import { getSvocId, getUserId, getAuthorizationToken } from '../utils/utils';

export function getEnrollmentStatusRequest(channel) {
  return {
    url: `/b2b/user/account/${getUserId()}/customer/${getSvocId()}/militaryDiscount/enrollment`,
    headers: {
      channelId: channel === 'mobile' ? 2 : 1
    }
  };
}

export function getRestartVerificationRequest(channel) {
  return {
    url: `/b2b/user/account/${getUserId()}/customer/${getSvocId()}/militaryDiscount/reset`,
    headers: {
      channelId: channel === 'mobile' ? 2 : 1
    }
  };
}
